import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveSeo } from './resolve';

const ATTR = 'data-seo-jsonld';

// Injects Schema.org JSON-LD per route. Kept separate from the OG/Twitter tag
// mutation so the two concerns never bleed into each other.
export function useSeoJsonLd(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    document
      .querySelectorAll(`script[${ATTR}]`)
      .forEach((el) => el.remove());

    const seo = resolveSeo(pathname);
    seo.jsonLd.forEach((data) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute(ATTR, 'true');
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll(`script[${ATTR}]`).forEach((el) => el.remove());
    };
  }, [pathname]);
}